export function bigSearchInitialFromFirstName(
  firstName: string
): string | null {
  const firstCharacter = firstName.trim().charAt(0);
  const initial = firstCharacter
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return /^[A-Za-z]$/.test(initial) ? initial.toUpperCase() : null;
}
